import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ReactElement } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import LandingPageLoyaltyDiscountedInsuranceBenefitsModal from './LandingPageLoyaltyDiscountedInsuranceBenefitsModal'

const image: App.Image = {
  id: '36fmxwdnmim0b53p9x7',
  title: 'Travel & Cancellation Protection',
}

interface Props {
  tier: App.LoyaltyTier
  benefitLabel: ReactElement
  discountPercent: number
}

function LandingPageLoyaltyDiscountedInsurance(props: Props) {
  const { tier, benefitLabel, discountPercent } = props

  const showModal = useContext(ModalContext)
  const intl = useIntl()

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyDiscountedInsuranceBenefitsModal
      image={image}
      discountPercent={discountPercent}
    />)
  }, [showModal, discountPercent])

  return <LandingPageLoyaltyBenefitTile
    heading={intl.formatMessage(
      {
        id: 'IqVEtPeOd-Vpcn1UjWhO',
        defaultMessage: 'Save {discountPercent}% on Travel & Cancellation Protection',
        description: 'Heading for loyalty discounted insurance benefit tile showing percentage discount',
      },
      { discountPercent },
    )}
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      {intl.formatMessage({
        id: 'BSC3ho2WvbUhu5hdcyBs',
        defaultMessage: 'Details',
        description: 'Link to open discounted insurance benefit details modal',
      })}
    </TextButton>}
  >
    <BodyText variant="medium">
      {intl.formatMessage(
        {
          id: 'psCCx1IlO_bQyLwiG437',
          defaultMessage: 'Travel with confidence. Enjoy {discountPercent}% off comprehensive travel protection, including cover for trip cancellations, medical emergencies, lost luggage and more. Peace of mind, for less.',
          description: 'Description of the discounted travel insurance loyalty benefit',
        },
        { discountPercent },
      )}
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyDiscountedInsurance
